export const fertigators_listing = (t: any) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },

  {
    Header: t("Farm Name"),
    accessor: "farm_name",
  },
  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  {
    Header: t("Field Name"),
    accessor: "field_name",
  },
  {
    Header: t("Location"),
    accessor: "Location",
    Cell: ({ cell: { value } }) => {
      return value ?? "-";
    },
  },
  {
    Header: t("Fertigator Code"),
    accessor: "fertigator_code",
  },

  {
    Header: t("Fertigator technique"),
    accessor: "fertigator_technique",
    Cell: ({ cell: { value } }) => {
      return t(value) ?? "-";
    },
  },
  {
    Header: t("Fertigator Power KWH"),
    accessor: "fertigator_power",
    Cell: ({ cell: { value } }) => {
      return value ?? "-";
    },
  },

  {
    Header: t("Tank Capacity Ltrs"),
    accessor: "Tank Capacity Ltrs",
    Cell: ({ cell: { value } }) => {
      return value ?? "-";
    },
  },
];
